/* mt-theme-shop.js — tag filtering + sidebar filters + count */
// @ts-nocheck
(function () {
    'use strict';
  
    function uniq(arr) {
      return Array.from(new Set(arr));
    }
  
    function getCardTags(cardEl) {
      var raw = (cardEl && cardEl.dataset && cardEl.dataset.tags) ? cardEl.dataset.tags : '';
      if (!raw) return [];
      return uniq(raw.split('|').map(function (s) { return String(s || '').trim(); }).filter(Boolean));
    }
  
    function getCardCategories(cardEl) {
      var raw = (cardEl && cardEl.dataset && cardEl.dataset.categories) ? cardEl.dataset.categories : '';
      if (!raw) return [];
      return uniq(raw.split('|').map(function (s) { return String(s || '').trim(); }).filter(Boolean));
    }
  
    function setCount(root, visible) {
      var start = visible > 0 ? 1 : 0;
      var end = visible;
  
      root.querySelectorAll('[data-mt-shop-range-start]').forEach(function (el) {
        el.textContent = String(start);
      });
      root.querySelectorAll('[data-mt-shop-range-end]').forEach(function (el) {
        el.textContent = String(end);
      });
      root.querySelectorAll('[data-mt-shop-range-total]').forEach(function (el) {
        el.textContent = String(visible);
      });
    }
  
    function getTagFromDropdown(root) {
      var select = root.querySelector('[data-mt-shop-tag-select]');
      if (!select) return '';
      return String(select.value || '').trim();
    }
  
    /** Filters live in __mtsSidebarWrap; on mobile drawer that node may be under body, outside section. */
    function getFilterQueryRoot(root) {
      var wrap = root.__mtsSidebarWrap;
      if (wrap && wrap.querySelector && wrap.querySelector('[data-mt-shop-filters]')) return wrap;
      return root;
    }
  
    function getSelectedCategories(root) {
      var arr = [];
      var scope = getFilterQueryRoot(root);
      scope.querySelectorAll('[data-mt-shop-filters] input[type="checkbox"][data-mt-shop-category]:checked').forEach(function (el) {
        arr.push(String(el.value || el.getAttribute('data-mt-shop-category') || '').trim());
      });
      return uniq(arr).filter(Boolean);
    }
  
    function matchesTagFilter(cardTags, tagOne) {
      if (!tagOne) return true;
      return cardTags.indexOf(tagOne) !== -1;
    }
  
    function matchesCategoryFilter(cardCats, selectedCats) {
      if (!selectedCats.length) return true;
      for (var i = 0; i < selectedCats.length; i++) {
        if (cardCats.indexOf(selectedCats[i]) === -1) return false;
      }
      return true;
    }
  
    function applyFilter(root) {
      var cards = Array.from(root.querySelectorAll('[data-mt-shop-card]'));
      var tagOne = getTagFromDropdown(root);
      var selectedCats = getSelectedCategories(root);
  
      var visible = 0;
      cards.forEach(function (card) {
        var tags = getCardTags(card);
        var cats = getCardCategories(card);
        var show = matchesTagFilter(tags, tagOne) && matchesCategoryFilter(cats, selectedCats);
        if (show) {
          card.removeAttribute('hidden');
          visible += 1;
        } else {
          card.setAttribute('hidden', '');
        }
      });
  
      setCount(root, visible);
    }
  
    function syncTagDisplay(root) {
      var sel = root.querySelector('[data-mt-shop-tag-select]');
      var disp = root.querySelector('[data-mt-shop-tag-display]');
      var wrap = root.querySelector('[data-mt-shop-tag-dropdown]');
      if (!sel || !disp) return;
      var v = String(sel.value || '');
      if (v === '' && wrap && wrap.dataset.mtShopDefaultLabel) {
        disp.textContent = wrap.dataset.mtShopDefaultLabel;
        return;
      }
      var idx = sel.selectedIndex;
      var opt = idx >= 0 ? sel.options[idx] : null;
      disp.textContent = opt ? String(opt.textContent || '').trim() : v;
    }
  
    function setTagOptionActive(root, value) {
      var v = String(value);
      root.querySelectorAll('[data-mt-shop-tag-option]').forEach(function (btn) {
        var bv = btn.getAttribute('data-value');
        if (bv == null) bv = '';
        var isOn = String(bv) === v;
        btn.classList.toggle('is-active', isOn);
        btn.setAttribute('aria-selected', isOn ? 'true' : 'false');
      });
    }
  
    function closeTagPanel(root) {
      var panel = root.querySelector('[data-mt-shop-tag-panel]');
      var trigger = root.querySelector('[data-mt-shop-tag-trigger]');
      if (panel) panel.setAttribute('hidden', '');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-open');
      }
      root.__mtsTagOpen = false;
    }
  
    function bindTagPanelGlobalOnce() {
      if (bindTagPanelGlobalOnce.__done) return;
      bindTagPanelGlobalOnce.__done = true;
      document.addEventListener('click', function (e) {
        var t = e.target;
        document.querySelectorAll('[data-mt-theme-shop]').forEach(function (root) {
          if (!root.__mtsTagOpen) return;
          if (t && root.contains(t)) return;
          closeTagPanel(root);
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('[data-mt-theme-shop]').forEach(function (root) {
          if (root.__mtsTagOpen) closeTagPanel(root);
        });
      });
    }
  
    function openTagPanel(root) {
      document.querySelectorAll('[data-mt-theme-shop]').forEach(function (other) {
        if (other !== root && other.__mtsTagOpen) closeTagPanel(other);
      });
      var panel = root.querySelector('[data-mt-shop-tag-panel]');
      var trigger = root.querySelector('[data-mt-shop-tag-trigger]');
      if (!panel || !trigger) return;
      panel.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('is-open');
      root.__mtsTagOpen = true;
      bindTagPanelGlobalOnce();
    }
  
    function initTagDropdown(root) {
      var select = root.querySelector('[data-mt-shop-tag-select]');
      var trigger = root.querySelector('[data-mt-shop-tag-trigger]');
      var panel = root.querySelector('[data-mt-shop-tag-panel]');
      if (!select || !trigger || !panel) return;
  
      syncTagDisplay(root);
      setTagOptionActive(root, String(select.value || ''));
  
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (root.__mtsTagOpen) {
          closeTagPanel(root);
        } else {
          openTagPanel(root);
        }
      });
  
      panel.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-mt-shop-tag-option]');
        if (!btn) return;
        e.preventDefault();
        var val = btn.getAttribute('data-value');
        if (val == null) val = '';
        select.value = val;
        syncTagDisplay(root);
        setTagOptionActive(root, val);
        closeTagPanel(root);
        applyFilter(root);
      });
  
      select.addEventListener('change', function () {
        syncTagDisplay(root);
        setTagOptionActive(root, String(select.value || ''));
        applyFilter(root);
      });
    }
  
    function bindSidebarFilters(root) {
      var box = root.querySelector('[data-mt-shop-filters]');
      if (!box) return;
  
      box.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.tagName !== 'INPUT') return;
        if (t.type !== 'checkbox') return;
  
        applyFilter(root);
      });
    }
  
    function updateHtmlDrawerScrollLock() {
      var any = document.querySelector('[data-mt-theme-shop].mts-filter-drawer-open');
      if (any) {
        document.documentElement.classList.add('mts-theme-shop-drawer-open');
      } else {
        document.documentElement.classList.remove('mts-theme-shop-drawer-open');
      }
    }
  
    function isMobileFilterViewport() {
      return window.innerWidth < 750;
    }
  
    function portalSidebarWrapToBody(root) {
      var wrap = root.__mtsSidebarWrap;
      var layout = root.querySelector('.mt-theme-shop__layout');
      if (!wrap || !layout || wrap.parentNode === document.body) return;
      if (!root.__mtsSidebarPlaceholder) {
        root.__mtsSidebarPlaceholder = document.createComment('mts-shop-sidebar-wrap');
        layout.insertBefore(root.__mtsSidebarPlaceholder, wrap);
      }
      document.body.appendChild(wrap);
    }
  
    function restoreSidebarWrapFromBody(root) {
      var wrap = root.__mtsSidebarWrap;
      var layout = root.querySelector('.mt-theme-shop__layout');
      var ph = root.__mtsSidebarPlaceholder;
      if (!wrap || wrap.parentNode !== document.body) return;
      if (layout && ph && ph.parentNode === layout) {
        layout.insertBefore(wrap, ph);
        ph.parentNode.removeChild(ph);
      } else if (layout) {
        layout.insertBefore(wrap, layout.firstChild);
        if (ph && ph.parentNode) ph.parentNode.removeChild(ph);
      }
      root.__mtsSidebarPlaceholder = null;
    }
  
    function clearDrawerCloseScheduled(root) {
      if (!root) return;
      if (root.__mtsDrawerCloseTimer) {
        clearTimeout(root.__mtsDrawerCloseTimer);
        root.__mtsDrawerCloseTimer = null;
      }
      if (root.__mtsDrawerTransitionEnd) {
        var wrap = root.__mtsSidebarWrap;
        var sidebar = wrap && wrap.querySelector('.mt-theme-shop__sidebar');
        if (sidebar) sidebar.removeEventListener('transitionend', root.__mtsDrawerTransitionEnd);
        root.__mtsDrawerTransitionEnd = null;
      }
    }
  
    function closeFilterDrawer(root) {
      if (!root) return;
      clearDrawerCloseScheduled(root);
      var wrap = root.__mtsSidebarWrap;
      var sidebar = wrap && wrap.querySelector('.mt-theme-shop__sidebar');
      var hadPortalOpen = wrap && wrap.classList.contains('mts-sidebar-portal-open');
      var reduced = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var useAnim = hadPortalOpen && sidebar && isMobileFilterViewport() && !reduced;
  
      function finalizeClose() {
        clearDrawerCloseScheduled(root);
        if (wrap) wrap.classList.remove('mts-sidebar-portal-open');
        restoreSidebarWrapFromBody(root);
        root.classList.remove('mts-filter-drawer-open');
        root.querySelectorAll('[data-mt-shop-filter-open]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
        updateHtmlDrawerScrollLock();
      }
  
      if (useAnim) {
        var done = false;
        function oneShot() {
          if (done) return;
          done = true;
          finalizeClose();
        }
        wrap.classList.remove('mts-sidebar-portal-open');
        root.__mtsDrawerTransitionEnd = function (e) {
          if (e.target !== sidebar || e.propertyName !== 'transform') return;
          oneShot();
        };
        sidebar.addEventListener('transitionend', root.__mtsDrawerTransitionEnd);
        root.__mtsDrawerCloseTimer = setTimeout(oneShot, 500);
        return;
      }
  
      finalizeClose();
    }
  
    function openFilterDrawer(root) {
      clearDrawerCloseScheduled(root);
      document.querySelectorAll('[data-mt-theme-shop].mts-filter-drawer-open').forEach(function (other) {
        if (other !== root) closeFilterDrawer(other);
      });
      closeTagPanel(root);
      if (isMobileFilterViewport()) {
        portalSidebarWrapToBody(root);
        var w = root.__mtsSidebarWrap;
        if (w) {
          var reducedOpen = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reducedOpen) {
            w.classList.add('mts-sidebar-portal-open');
          } else {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                w.classList.add('mts-sidebar-portal-open');
              });
            });
          }
        }
      }
      root.classList.add('mts-filter-drawer-open');
      root.querySelectorAll('[data-mt-shop-filter-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      updateHtmlDrawerScrollLock();
    }
  
    function bindMobileFilterDrawer(root) {
      var backdrop = root.querySelector('[data-mt-shop-filter-drawer-backdrop]');
      var openBtns = root.querySelectorAll('[data-mt-shop-filter-open]');
      if (!openBtns.length && !backdrop) return;
  
      openBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          openFilterDrawer(root);
        });
      });
  
      root.querySelectorAll('[data-mt-shop-filter-done]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeFilterDrawer(root);
        });
      });
  
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closeFilterDrawer(root);
        });
      }
  
      if (!bindMobileFilterDrawer.__escBound) {
        bindMobileFilterDrawer.__escBound = true;
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          document.querySelectorAll('[data-mt-theme-shop].mts-filter-drawer-open').forEach(function (el) {
            closeFilterDrawer(el);
          });
        });
        window.addEventListener('resize', function () {
          if (window.innerWidth < 750) return;
          document.querySelectorAll('[data-mt-theme-shop].mts-filter-drawer-open').forEach(function (el) {
            closeFilterDrawer(el);
          });
        });
      }
    }
  
    function initBlurUp(root) {
      root.querySelectorAll('.mt-theme-shop__img-wrap .mt-theme-shop__img').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function () {
            img.classList.add('is-loaded');
          });
        }
      });
    }

    function init(root) {
      if (!root || root.dataset.mtThemeShopInit === 'true') return;
      root.dataset.mtThemeShopInit = 'true';

      root.__mtsSidebarWrap = root.querySelector('.mt-theme-shop__sidebar-wrap');

      initTagDropdown(root);
      bindSidebarFilters(root);
      bindMobileFilterDrawer(root);
      applyFilter(root);
      initBlurUp(root);
    }
  
    document.querySelectorAll('[data-mt-theme-shop]').forEach(init);
  
    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      var root = event.target.querySelector && event.target.querySelector('[data-mt-theme-shop]');
      if (root) init(root);
    });
  })();
  
  